/**
 * RATE_LIMITED helpers: detect the 429 payload and show a lasting countdown toast.
 */

import { toast } from "sonner";
import { RateLimitNotice } from "@/components/rate-limit-notice";
import { ApiError } from "@/lib/api";
import { describeError } from "@/lib/errors";
import { isRateLimitedPayload, type RateLimitedPayload } from "@/shared/errors";

export function remainingSeconds(resetAt: string): number {
  const until = Date.parse(resetAt);
  if (!Number.isFinite(until)) return 0;
  return Math.max(0, Math.ceil((until - Date.now()) / 1000));
}

export function rateLimitedFromError(error: unknown): RateLimitedPayload | null {
  if (!(error instanceof ApiError)) return null;
  return isRateLimitedPayload(error.payload) ? error.payload : null;
}

export function toastApiError(error: unknown): void {
  const payload = rateLimitedFromError(error);
  if (payload) {
    const remainingMs = remainingSeconds(payload.resetAt) * 1000;
    toast.error(<RateLimitNotice payload={payload} />, { duration: remainingMs + 500 });
    return;
  }
  toast.error(describeError(error));
}
